<template>
  <div class="banner _clearboth hide-sm">
    <div class="container">
      <ul class="banner__list">
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Banner'
  }
</script>



// WEBPACK FOOTER //
// Banner.vue?7b9d7e8d